/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const challengeSenseSchema = z.object({
  partOfSpeech: z.string(),
  definition: z.string(),
  register: z.string().optional(),
  examples: z.array(z.string()).optional(),
  synonyms: z.array(z.string()).optional(),
});

export type IChallengeSense = z.infer<typeof challengeSenseSchema>;
